import { API_BASE_URL } from '../config/constants';

/**
 * 認証済みのAPIリクエストを送信する関数
 */
export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('token');
  const requestStartTime = performance.now();
  const method = options.method || 'GET';
  
  console.log(`API リクエスト開始: ${method} ${url}`);
  
  if (!token) {
    console.error('JWT トークンが見つかりません');
    return Promise.reject(new Error('認証トークンがありません'));
  }

  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`
  };

  try {
    const response = await fetch(url, {
      ...options,
      headers
    });
    
    const requestEndTime = performance.now();
    const duration = Math.round(requestEndTime - requestStartTime);
    
    if (response.ok) {
      console.log(`API リクエスト成功: ${method} ${url} (${duration}ms) - ステータス: ${response.status}`);
    } else {
      console.warn(`API リクエスト失敗: ${method} ${url} (${duration}ms) - ステータス: ${response.status} ${response.statusText}`);
    }
    
    return response;
  } catch (error) {
    console.error(`API リクエスト例外: ${method} ${url}`, error);
    throw error;
  }
}
